<template>
    <modal size="lg" :height-max="true" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit Positions</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ company.name }}</div>
                    <div><span class="text-muted">Insurance Plan: </span>{{ insurancePlan.plan_name }}</div>
                </div>
            </div>

            <p class="mb-0">Select the positions that will use this insurance plan.</p>

            <position-selector v-if="positionsLoaded" :all-positions="allCompanyPositions" :companies="[company]" v-model="formData.positions"/>

        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PositionSelector from '@/pages/client/Settings/components/PositionSelector'

export default {
    props: ['client', 'insurancePlan', ],
    mixins: [FormMixin, ModalMixin],
    emits: ['close', 'updated', ],
    components: {PositionSelector, },
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.insurancePlan.company_id)
        },
        allCompanyPositions() {
            if (!this.positionsLoaded) {return []}
            return this.allPositions.filter(p => p.company_id == this.insurancePlan.company_id)
        },
    },
    data() {
        return {
            formData: this.makeFormData(),
            allPositions: [],
            positionsLoaded: false,
        }
    },
    mounted() {
        this.getPositions()
    },
    methods: {
        getPositions() {
            this.$api.get(`/clients/${this.client.id}/positions`).then(resp => {
                this.allPositions = resp
                this.allPositions.sort((a, b) => {return a.terminal_value.toLowerCase() > b.terminal_value.toLowerCase() ? 1 : -1})
                this.positionsLoaded = true
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
            })
        },
        makeFormData() {
            const data = {
                positions: []
            }
            this.insurancePlan.insurance_plan_positions.forEach(ipp => {
                data.positions.push(ipp.position_id)
            })
            return data
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.put(`/clients/${this.client.id}/settings/insurance-plans/${this.insurancePlan.id}/positions`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated')
                this.$bus.showInfo(`Successfully updated positions.`)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        }
    }
}
</script>
